// extracted by mini-css-extract-plugin
export default {"page":"SelectionPage_page__GAIMT","topSection":"SelectionPage_topSection__WdHar","leftContainer":"SelectionPage_leftContainer__IaunK","midSection":"SelectionPage_midSection__p3f6+"};